'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _BrowserTest = require('../../utils/BrowserTest');

var _DomEvents = require('../../utils/DomEvents');

var _tshirtSize = require('../../utils/propTypes/tshirtSize');

var _CheckboxConstants = require('../CheckboxConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ToggleInputWrapper = (0, _react.forwardRef)(function (props, ref) {
  var alignment = props.alignment,
      checked = props.checked,
      children = props.children,
      className = props.className,
      description = props.description,
      descriptionId = props.descriptionId,
      descriptionLayout = props.descriptionLayout,
      disabled = props.disabled,
      indicator = props.indicator,
      inline = props.inline,
      input = props.input,
      labelClassName = props.labelClassName,
      onChange = props.onChange,
      readOnly = props.readOnly,
      size = props.size,
      rest = _objectWithoutProperties(props, ['alignment', 'checked', 'children', 'className', 'description', 'descriptionId', 'descriptionLayout', 'disabled', 'indicator', 'inline', 'input', 'labelClassName', 'onChange', 'readOnly', 'size']);

  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);

  return _react2.default.createElement(
    'div',
    _extends({}, rest, {
      className: (0, _classnames2.default)(className, _CheckboxConstants.ALIGNMENT_CLASSES[alignment], _CheckboxConstants.SIZE_OPTIONS[shorthandSize], {
        'private-checkbox--disabled': disabled,
        'private-checkbox--readonly': readOnly,
        'private-checkbox--inline': inline,
        'private-checkbox--stack-contents': description && descriptionLayout === 'vertical'
      }),
      ref: ref
    }),
    _react2.default.createElement(
      'label',
      {
        className: (0, _classnames2.default)('private-checkbox__label', labelClassName),
        onClick: function onClick(evt) {
          if ((0, _BrowserTest.isFirefox)() && (0, _DomEvents.isModifierPressed)(evt)) {
            onChange(_extends({}, evt, { type: 'change', target: { checked: !checked } }));
          }
        }
      },
      _react2.default.createElement(
        'span',
        { className: 'private-checkbox__inner' },
        input,
        indicator,
        children && _react2.default.createElement(
          'span',
          {
            className: (0, _classnames2.default)('private-checkbox__text', {
              'private-checkbox__text--small': shorthandSize === 'sm'
            })
          },
          children
        )
      )
    ),
    description && _react2.default.createElement(
      'span',
      { className: 'private-checkbox__desc', id: descriptionId },
      description
    )
  );
});

ToggleInputWrapper.displayName = 'ToggleInputWrapper';

if (process.env.NODE_ENV !== 'production') {
  ToggleInputWrapper.propTypes = {
    alignment: _propTypes2.default.string.isRequired,
    checked: _propTypes2.default.bool,
    children: _propTypes2.default.node,
    className: _propTypes2.default.string,
    description: _propTypes2.default.node,
    descriptionId: _propTypes2.default.string.isRequired,
    descriptionLayout: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.bool,
    indicator: _propTypes2.default.node.isRequired,
    inline: _propTypes2.default.bool,
    input: _propTypes2.default.node.isRequired,
    labelClassName: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    readOnly: _propTypes2.default.bool,
    size: _propTypes2.default.string
  };
}

exports.default = ToggleInputWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/input/internal/ToggleInputWrapper.js
// module id = 578
// module chunks = 177